import type { IFilters } from '../queries/banners.graphql';

interface IObjectWithFilters {
    filters?: IFilters | null;
}

export interface DemographicsFilter {
    isAuthenticated: boolean;
    countryCode?: string;
    jurisdiction: string;
    currentTime: number;
    tags: string[];
    device: Device;
}

export enum Device {
    MOBILE = 'MOBILE',
    DESKTOP = 'DESKTOP',
}

export function applyDemographicsFilter<ObjectType extends IObjectWithFilters>(
    arrayList: Array<ObjectType | null | undefined>,
    demographicsFilter: DemographicsFilter,
) {
    return arrayList.filter((item): item is Exclude<typeof item, null | undefined> => {
        if (!item) {
            return false;
        }

        if (!item.filters) {
            return true;
        }

        if (
            demographicsFilter.isAuthenticated &&
            !(
                item?.filters?.authenticationStatus?.forLoggedIn ===
                demographicsFilter.isAuthenticated
            )
        ) {
            return false;
        }

        if (
            !demographicsFilter.isAuthenticated &&
            !(
                !item?.filters?.authenticationStatus?.forLoggedOut ===
                demographicsFilter.isAuthenticated
            )
        ) {
            return false;
        }

        if (
            demographicsFilter.countryCode &&
            item?.filters?.countries &&
            item.filters.countries.length > 0 &&
            !item.filters.countries.includes(demographicsFilter.countryCode)
        ) {
            return false;
        }

        if (
            item?.filters?.jurisdictions &&
            item.filters.jurisdictions.length > 0 &&
            !item.filters.jurisdictions.includes(demographicsFilter.jurisdiction.toString())
        ) {
            return false;
        }

        if (item.filters?.startDate && item.filters.startDate > demographicsFilter.currentTime) {
            return false;
        }

        if (item.filters?.endDate && item.filters.endDate < demographicsFilter.currentTime) {
            return false;
        }

        if (
            item.filters?.devices &&
            item.filters.devices.length > 0 &&
            !item.filters?.devices.includes(demographicsFilter.device)
        ) {
            return false;
        }

        if (
            item.filters?.tags &&
            item.filters.tags.length > 0 &&
            !item.filters?.tags.every((value) => demographicsFilter.tags?.includes(value))
        ) {
            return false;
        }

        return true;
    });
}
